<template>
  <div class="flex flex_column" style="f">
    <div id="containerID">
    </div>
    <el-button @click="paizhao" v-if="AudioVideoshow" type="primary" style="width:320px;margin-top:20px;">拍照</el-button>
  </div>
  <!-- <iframe style="width:330px;height:600px;margin:0 auto;" allow="microphone;camera;midi;encrypted-media;"
      src="https://serviceapi.qingjuck.cn/esand/index.html">

    </iframe> -->
  <div v-if="AudioVideoshow == false">
    <div class="tishitit">请使用app或小程序扫码</div>

    <div class="qrcode-img">
      <div id="login-qrcode" class="flex flex_column login-qrcode"></div>
      <div class="qrcode-error" v-if="qrcodeBeoverdue">
        <p>{{ qrcodeMsg }}</p>
        <button class="refresh" @click="refreshQrcode">刷新二维码</button>
      </div>
    </div>
  </div>
  <div v-if='esand == true'>
    <iframe style="width:330px;height:420px;margin:0 auto;" allow="microphone;camera;midi;encrypted-media;"
      :src="`https://serviceapi.qingjuck.cn/esand/index.html?uuid=${stuinfo.id}&b=2`">

    </iframe>
  </div>

</template>

<script setup>
import {
  ref,
  nextTick,
  onMounted,
  onBeforeUnmount,
  computed,
  reactive,
  defineEmit,
  useContext,
  watch,
  defineEmits,
  toRaw
} from 'vue';
import WebCamera from 'web-camera.js'
import { client, getObjectUrl, objectToBuffer, dataURLtoFile } from "@/utils/ali-oss";
import { dataURLtoBlob } from "@/utils/compressImage";
import { ElLoading } from 'element-plus'
import { identityphotoNew, getKeysApi, getTenantParamByKey, getUserInfoApi } from '@/api/index.js'
import { uuid, setInitImg, urlConversion } from '@/utils/index.js'
import QRCode from 'qrcodejs2';

import { useStore } from 'vuex';
const store = useStore();
const emit = defineEmits(['change'])
let options = {
  el: '#containerID'
}
let camera = null
function paizhao () {
  const loadingInstance = ElLoading.service({

  })
  camera.toBase64(function (dataURL) {
    let reader2 = new FileReader();
    reader2.readAsArrayBuffer(dataURLtoBlob(dataURL));

    reader2.onload = function (event) {
      let date = getNowFormatDate();
      client().put(`upload/${date}/${uuid()}.png`, objectToBuffer(event.target.result)).then(ret => {
        if (ret.name) {
          // 获得图片地址
          var data = {
            "imageFile": ret.name
          };
          identityphotoNew(data).then(res => {

            loadingInstance.close()
            if (res.code == 200) {
              getKeysApi('config_score_person').then(ress => {

                let face_pass = 70
                ress.data.config_score_person.forEach(item => {
                  if (item.value == 'face_pass') {
                    face_pass = item.key
                  }
                })
                if (parseInt(res.data) > face_pass) {
                  emit('change', {
                    data: true,
                    msg: '成功',
                    bestImg: ret.name,
                    confident: res.data || 0,
                  })

                } else {
                  emit('change', {
                    data: false,
                    msg: '失败',
                    bestImg: ret.name,
                    confident: res.data || 0,
                  })
                }
              })
            } else {
              emit('change', {
                msg: res.data.msg
              })
            }
          })

        }
      });
    }

  }, 'png');
}
function getAudioVideo (constraintsData) {
  if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {};
  }
  if (navigator.mediaDevices.getUserMedia === undefined) {
    navigator.mediaDevices.getUserMedia = function (constraints) {
      // 首先，如果有getUserMedia的话，就获得它
      var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
      if (!getUserMedia) {
        return Promise.reject({ code: 404 });
      }

      // 否则，为老的navigator.getUserMedia方法包裹一个Promise

      return new Promise(function (resolve, reject) {
        getUserMedia.call(navigator, constraints, resolve, reject);
      });
    }
  }
  return navigator.mediaDevices.getUserMedia(constraintsData)
}
const AudioVideoshow = ref(null)
const qrcodeBeoverdue = ref(false);
const qrcodeMsg = ref('');
function renderQrcode () {
  document.querySelector('#login-qrcode').innerHTML = '';
  qrcodeBeoverdue.value = false
  let id = uuid()
  let userId = ''
  const text = {
    id,
    userId,
    type: 'slrz',
  }
  qrcodeMsg.value = '';
  new QRCode('login-qrcode', {
    width: 164,
    height: 164,
    text: JSON.stringify(text),
  });
  connectService(id)

}
let source = null;
function connectService (uuid) {
  if (window.EventSource) {
    source = new EventSource('/api/blade-app/website/connect/' + uuid);
    source.onopen = function (event) {
      console.log(event, '???');
    };
    source.onmessage = function (event) {
      console.log(event);
      let res = event.data;
      if (!res) {
        return;
      }
      if (res === 'STUDY::SSE::PROCESSSTUDY') {
        qrcodeMsg.value = '扫码中';
        qrcodeBeoverdue.value = true;
        return;
      }
      try {
        let data = JSON.parse(res)
        if (data.type == 'success') {
          source.close()
          let res = data.res
          console.log(res)
          if (res.code == 200) {
            getKeysApi('config_score_person').then(ress => {

              let face_pass = 70
              ress.data.config_score_person.forEach(item => {
                if (item.value == 'face_pass') {
                  face_pass = item.key
                }
              })
              if (parseInt(res.data) > face_pass) {
                emit('change', {
                  data: true,
                  msg: '成功',
                  bestImg: data.name,
                  confident: res.data || 0,
                })

              } else {
                emit('change', {
                  data: false,
                  msg: '失败',
                  bestImg: data.name,
                  confident: res.data || 0,
                })
              }
            })
          } else {
            emit('change', {
              msg: res.data.msg
            })
          }
        }
        // if (res == 'STUDY::SSE::RESULT::1') {
        //   qrcodeMsg.value = '认证成功';
        //   ElMessage.success('认证成功')
        //   showModal.value = false
        //   callbacks()
        // } else if (res == 'STUDY::SSE::RESULT::0') {
        //   qrcodeMsg.value = '认证失败';
        //   console.log(res);
        //   message.error('认证失败');
        // }
      } catch (err) {
        console.log(err)
        message.error('扫码出现错误，请刷新页面后重试！');
        qrcodeMsg.value = '请刷新后重试';
        qrcodeBeoverdue.value = true;
      }
    };
    source.onerror = function (event) {
      message.error('扫码出现异常，请刷新页面后重试！');
      qrcodeMsg.value = '请刷新页面后重试';
      qrcodeBeoverdue.value = true;
      cancelConnect();
    };
  }
}
function refreshQrcode () {
  document.querySelector('#login-qrcode').innerHTML = '';
  if (source) {
    source.close();
  }
  // source.close()
  renderQrcode()

}
function cancelConnect () {
  if (source) {
    source.close();
    source = null;
  }
}
const getNowFormatDate = () => {
  // 获取当月时间 yyyy-MM-dd
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = '0' + month;
  }
  if (strDate >= 1 && strDate <= 9) {
    strDate = '0' + strDate;
  }
  return year + '-' + month + '-' + strDate;
}
const esand = ref(false)
const stuinfo = ref({})
onBeforeUnmount(() => {
  window.removeEventListener('message', cancelConnect);
});
onMounted(() => {
  getAudioVideo({ video: true }).then(res => {
    console.log(res)
    try {
      getTenantParamByKey({ key: 'hide_face_verification_type' }).then(res => {
        if (res.data == 2) {
          getUserInfoApi()
            .then(res => {
              if (res) {
                console.log(res, '学员信息')
                if (res.data) {
                  stuinfo.value = res.data
                  esand.value = true


                }
              }
            })
          let pops = true
          window.addEventListener('message', (e) => {

            console.log(e, '页面监听')
            let dataMessage = e.data
            if (dataMessage.appid) {
              if (pops) {
                pops = false
              } else {
                return
              }
              if (dataMessage.confident) {
                console.log(666)
                setInitImg(urlConversion(dataMessage.bestImg), (e) => {
                  console.log(e, '下载图片')
                  let date = getNowFormatDate();
                  client().put(`upload/${date}/${uuid()}.jpg`, e).then(ret => {
                    if (ret.name) {
                      console.log(ret)
                      getKeysApi('config_score_person').then(ress => {
                        let face_pass = 70
                        ress.data.config_score_person.forEach(item => {
                          if (item.value == 'face_pass') {
                            face_pass = item.key
                          }
                        })
                        if (parseInt(dataMessage.confident) > face_pass) {
                          pops = true
                          emit('change', {
                            data: true,
                            msg: '成功',
                            bestImg: ret.name,
                            confident: dataMessage.confident || 0,
                          })

                        } else {
                          pops = true

                          emit('change', {
                            data: false,
                            msg: '失败',
                            bestImg: ret.name,
                            confident: dataMessage.confident || 0,
                          })
                        }
                      })
                    }
                  });
                })

                // console.log(dataURLtoFile(dataMessage.bestImg))

              }
            }
          });
        } else {
          AudioVideoshow.value = true

          camera = new WebCamera(options);
          camera.ready();
        }
      })

    } catch (err) {
    }
  }).catch(err => {

    AudioVideoshow.value = false
    nextTick(() => {
      renderQrcode()

    })

  })


});
</script>

<style lang="scss">
.flex_column {
  flex-direction: column;
  align-items: center;
}
.qrcode-img {
  position: relative;
  box-shadow: 0px 0px 1px 1px rgba(28, 28, 32, 0.05), 0px 8px 24px rgba(28, 28, 32, 0.12);
  border-radius: 10px;
  width: 180px;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
  font-size: 14px;
  background-color: #fff;
  overflow: hidden;
  padding: 8px;
}
.qrcode-error {
  background-color: rgba(255, 255, 255, 0.95);
  position: absolute;
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;

  > p {
    color: #222;
    margin-top: 75px;
    margin-bottom: 8px;
    text-align: center;
    font-size: 18px;
  }

  .refresh {
    font-size: 12px;
    color: #f0f0f0;
    background: #1890ff;
    line-height: 24px;
    height: 24px;
    width: auto;
    padding: 0px 10px;
    border-radius: 30px;
    border: 0;
    margin: 0 auto;
    display: block;
  }
}
.tishitit {
  font-size: 18px;
  text-align: center;
}
</style>